import { Credential } from '@core/models';

/**
 * Pure domain rule to evaluate whether a client possesses an active authenticated credential.
 */
export function isClientAuthenticated(auth?: Credential | null): boolean {
	return Boolean(auth);
}
